import type { ReactNode } from "react";
import type { LucideIcon } from "lucide-react";

/**
 * What a list says when it has nothing in it.
 *
 * Never just "nothing here": an empty screen with one grey line reads as a page
 * that failed to load. This names the state and, where there is one, the next
 * step - so the reader can tell "you have no invoices" from "something broke".
 */
export function EmptyState({
  icon: Icon,
  title,
  body,
  action,
}: {
  icon: LucideIcon;
  title: string;
  body?: string;
  action?: ReactNode;
}) {
  return (
    <div className="flex flex-col items-center px-6 py-12 text-center">
      <span className="flex size-12 items-center justify-center rounded-2xl bg-muted text-muted-foreground">
        <Icon className="size-6" />
      </span>
      <p className="mt-4 font-semibold">{title}</p>
      {body && <p className="mt-1 max-w-sm text-pretty text-sm text-foreground/70">{body}</p>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}
